
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getPuestosTrabajo } from "../../../../redux/actions/afiliaciones";
import FormikActions from "../../../commons/formik/FormikActions";
import FormikAutocomplete from "../../../commons/formik/FormikAutocomplete";
import FormikTextField from "../../../commons/formik/FormikTextField";
import { StyledResolucion } from "../../../styled/Prevencion";
import { nuevoPuestoValidation } from "./nuevoPuestoValidation";

const NuevoPuestoForm = ({ handleSubmit, initialValues, handleClose, open }) => {

  const dispatch = useDispatch();
  const puestos = useSelector((state) => state.resolucion.puestos.data);
  const ciouList = useSelector((state) => state.afiliaciones.puestosTrabajo.data)

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>
        Nuevo Puesto
      </DialogTitle>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => handleSubmit(values)}
        validationSchema={() => nuevoPuestoValidation(puestos)}
      >
        {() => (
          <Form>
            <DialogContent>
              <Grid container>
                <StyledResolucion.DialogGridItem item xs={12}>

                  <FormikTextField
                    name="nombre"
                    label="Puesto *"
                    fullWidth
                  />
                </StyledResolucion.DialogGridItem>
                <StyledResolucion.DialogGridItem item xs={12}>
                  <FormikAutocomplete
                    name="ciuo"
                    label="CIUO *"
                    fullWidth
                    options={ciouList}
                    getOptions={() => dispatch(getPuestosTrabajo())}
                  />
                </StyledResolucion.DialogGridItem>
              </Grid>
            </DialogContent>

            <DialogActions>
              <FormikActions handleCancel={handleClose} />
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}

export default NuevoPuestoForm